import {
    partnerDetails,
    cashoutPartnerBalance,
    partnerTableHistory,
    partnerChart
} from "../api/partner";
import ResolvedException from "./exception"
import store from '../store'


export const handleGetPartnerDetails = async () => {
    try {
        const response = await partnerDetails(store.getters['userStore/getAuthToken']);
        store.commit('userStore/setPartnerDetail', response.data.data)
        return response
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}



export const handleCashoutPartnerBalance = async (cryptoAddress) => {
    try {
        const response = await cashoutPartnerBalance(store.getters['userStore/getAuthToken'], cryptoAddress);
        handleGetPartnerDetails()
        return response
    } catch (e) {
        // console.log(e)
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}

export const handleGetPartnerTableHistory = async (type, page, limit) => {
    try {
        const response = await partnerTableHistory(store.getters['userStore/getAuthToken'], type, page, limit);
        return response
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}

export const handleGetPartnerChart = async (startTime, endTime) => {
    try {
        const response = await partnerChart(store.getters['userStore/getAuthToken'], startTime, endTime);
        return response;
    } catch (e) {
        throw new ResolvedException(e.response.data.message, e.response.data.error)
    }
}